import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../store/actions";

const VestigingContext = React.createContext({ vestiging: null });

export const useVestigingContext = () => React.useContext(VestigingContext);

function VestigingProvider(props) {
  useEffect(() => {
    props.setVestiging(props.vestiging);
  }, [props.vestiging]);
  return <VestigingContext.Provider value={{ vestiging: props.vestiging }}>{props.children}</VestigingContext.Provider>;
}

VestigingProvider.propTypes = {
  vestiging: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => {
  return {
    setVestiging: (vestiging) => dispatch({ type: actions.SET_VESTIGING, vestiging }),
  };
};

export default connect(null, mapDispatchToProps)(VestigingProvider);
